import { EventCatalogFromKeys, EventType } from "../types";

export const VolunteerEventKeys = {
  VOLUNTEER_ERROR: "volunteer-error",
  VOLUNTEER_NEED_CLAIM_ATTEMPT: "volunteer-need-claim-attempt",
  VOLUNTEER_NEED_CLAIM_FAILURE: "volunteer-need-claim-failure",
  VOLUNTEER_NEED_CLAIM_SUCCESS: "volunteer-need-claim-success",
} as const;

export const VolunteerEventCatalog: EventCatalogFromKeys<
  typeof VolunteerEventKeys
> = {
  [VolunteerEventKeys.VOLUNTEER_ERROR]: {
    description: "Volunteer encountered an error",
    eventType: EventType.ERROR,
    id: VolunteerEventKeys.VOLUNTEER_ERROR,
  },
  [VolunteerEventKeys.VOLUNTEER_NEED_CLAIM_ATTEMPT]: {
    description: "Public user attempted to claim a need",
    eventType: EventType.INTERACTION,
    id: VolunteerEventKeys.VOLUNTEER_NEED_CLAIM_ATTEMPT,
  },
  [VolunteerEventKeys.VOLUNTEER_NEED_CLAIM_FAILURE]: {
    description: "Public user failed to claim a need",
    eventType: EventType.ERROR,
    id: VolunteerEventKeys.VOLUNTEER_NEED_CLAIM_FAILURE,
  },
  [VolunteerEventKeys.VOLUNTEER_NEED_CLAIM_SUCCESS]: {
    description: "Public user successfully claimed a need",
    eventType: EventType.INTERACTION,
    id: VolunteerEventKeys.VOLUNTEER_NEED_CLAIM_SUCCESS,
  },
};
